<template>
  <div>
    <div id="here" class="card app-center-widget-holder" style="display: none">
      <div class="card-header cardHere">
        <div id="here-content" class="div-here"></div>

        <div>
          <button type="button" class="close" @click="cancelHere()">
            <span>&times;</span>
          </button>
        </div>
      </div>
    </div>
    <el-dialog
      title="Ingrese un número de DNI, RUC, SOT o Carnet de Extranjería"
      :visible.sync="centerDialogDni"
      width="30%"
      center
    >
      <select v-model="document" class="select-css" id="documents">
        <option
          v-for="item in documents"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></option>
      </select>
      <vs-input
        style="margin-top: 20px; width: 100%"
        type="number"
        v-model="dni"
        label="Documento:"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogDni = false">Cancel</el-button>
        <el-button type="primary" @click="searchValidation">Buscar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapMutations } from "vuex";

// const DEFAULT_TOKEN = "c7fab301-31d8-4618-b452-bc82e361d9bf";

export default {
  data() {
    return {
      access_token: process.env.VUE_APP_TOKEN_APIS,
      marker: null,
      urlReverse: "",
      isOpenInformation: false,
      centerDialogDni: false,
      dni: "",
      user:{},
      document: "DNI",
      documents: [
        { label: "DNI", value: "DNI" },
        { label: "RUC", value: "RUC" },
        { label: "SOT", value: "SOT" },
        { label: "Carnet extranjeria", value: "carnet-extranjeria" },
      ],
    };
  },
  created() {
    this.urlReverse = process.env.VUE_APP_GEOCODING;
  },
 
  mounted() {
    if (this.checkLogin()) {
      const tokenData = JSON.parse(window.localStorage.getItem("geodir_Token"));
      this.access_token = tokenData.data.access_token;

      this.user = JSON.parse(window.localStorage.getItem("user"));
    }

    let mapcontext = {
      text: "¿Qué hay aquí?",
      callback: this.search,
      index: 3,
      eventoclick: "",
    };

    this.map.contextmenu.insertItem(mapcontext, mapcontext.index);

    this.map.on("click", this.search);
  },
  computed: {
    ...mapState(["map"]),
  },
  methods: {
    checkLogin() {
      return this.$store.state.isLoggedIn;
    },
    search(e) {
      //Si existe ya un icono dibujado borrar
      /*this.marker = this.$store.state.markerSearcherReverse;
				console.log('MARCADOR');
				console.log(this.marker);*/

      if (this.isOpenInformation) {
        $("#here").hide();

        this.marker = this.$store.state.markerSearcherReverse;

        if (this.marker) {
          this.map.removeLayer(this.marker);
        }

        /*this.map.removeLayer(this.marker);*/
        this.isOpenInformation = false;
      } else {
        this.eventoclick = e;
        //this.centerDialogDni = true;
        this.searchReverse();
      }
    },

    searchValidation() {
      switch (this.document) {
        case "DNI":
          if (this.dni.length != 8) {
            this.$notify({
              title: "Aviso",
              message: "No coincide con la longitud de un DNI",
              type: "warning",
            });
            return;
          }

          if (this.dni == "00000000") {
            this.$notify({
              title: "Aviso",
              message: "DNI invalido",
              type: "warning",
            });
            return;
          }

          break;
        case "RUC":
          if (this.dni.length != 11) {
            this.$notify({
              title: "Aviso",
              message: "No coincide con la longitud de un RUC",
              type: "warning",
            });
            return;
          }

          if (this.dni == "00000000000") {
            this.$notify({
              title: "Aviso",
              message: "DNI invalido",
              type: "warning",
            });
            return;
          }
          break;
        case "SOT":
          if (this.dni.length != 8) {
            this.$notify({
              title: "Aviso",
              message: "No coincide con la longitud de SOT",
              type: "warning",
            });
            return;
          }
          if (this.dni == "00000000") {
            this.$notify({
              title: "Aviso",
              message: "DNI invalido",
              type: "warning",
            });
            return;
          }
          break;
        case "carnet-extranjeria":
          if (this.dni.length != 12) {
            this.$notify({
              title: "Aviso",
              message: "No coincide con la longitud del carnet de extranjeria",
              type: "warning",
            });
            return;
          }
          if (this.dni == "000000000000") {
            this.$notify({
              title: "Aviso",
              message: "DNI invalido",
              type: "warning",
            });
            return;
          }
          break;
        default:
        // code block
      }

      this.searchReverse();
    },

    searchReverse() {
      this.isOpenInformation = true;

      var latitud = this.eventoclick.latlng.lat.toFixed(6);
      var longitud = this.eventoclick.latlng.lng.toFixed(6);

      this.$store.commit("SET_LATITUD_GENERAL", latitud);
      this.$store.commit("SET_LONGITUD_GENERAL", longitud);

      let urlSearch = `${this.urlReverse}latlon=${latitud},${longitud}&maps=true&mapsaccount=${this.user.email}&detail=${this.document}:${this.dni}`;

      let self = this;

      axios
        .get(urlSearch)
        .then((response) => {
          self.centerDialogDni = false;
          self.dni = "";

          const data = response.data.length != 0 ? response.data[0] : [];

          const segments = {
            via: "route",
            numero_via: "route_number",
            adminLevel3: "admin_level_3",
            postalCode: "postal_code",
          };

          let dataReverse = response.data;

          let result = dataReverse.results[0];
          let segmentsReverse = result.address_segments;

          let valueRoute = "";
          let valueRouteNumber = "";
          let valueAdminLevel = "";
          let valuePostalCode = "";

          let place_id = result.place_id;
          let address = result.standard_address;

          for (const codesegment in segmentsReverse) {
            var segment = segmentsReverse[codesegment];

            var haveRoute = segment.types.includes(segments.via);
            if (haveRoute) {
              valueRoute = segment.name;
            }
            var haveRouteNumber = segment.types.includes(segments.numero_via);
            if (haveRouteNumber) {
              valueRouteNumber = segment.name;
            }
            var haveAdminLevel3 = segment.types.includes(segments.adminLevel3);
            if (haveAdminLevel3) {
              valueAdminLevel = segment.name;
            }

            var havePostalCode = segment.types.includes(segments.postalCode);
            if (havePostalCode) {
              valuePostalCode = segment.name;
            }
          }

          // let id = data.id;
          // let via = data.tipo + " " + data.via + " " + data.puerta;
          // let distrito = data.distrito;
          // let codigo_postal = data.codigo_postal;

          if (result.length == 0) {
            console.log("no hay ningun resultado");

            //this.searchDistritoReverse(latitud, longitud);
          } else {
            $("#here-content").html(
              "<b>" +
                valueRoute +
                " " +
                valueRouteNumber +
                "</b><br>" +
                valueAdminLevel +
                " " +
                valuePostalCode +
                '<br><span class="coordinates">' +
                latitud +
                ", " +
                longitud +
                "</span>"
            );
            $("#here").show();

            var customIcon = new L.Icon({
              iconUrl: require("../../assets/images/icon_marker_2.png"),
              //iconSize: [25, 35],
              iconAnchor: [12, 18],
              className: "iconReverse",
              //popupAnchor: [0, -38]
            });

            this.marker = L.marker([latitud, longitud], {
              icon: customIcon,
            }).addTo(this.map);

            this.$store.commit("setMarkerSearcherReverse", this.marker);
            this.$store.commit("SET_PLACE_ID", place_id);
            this.$store.commit("SET_ADDRESS", address);
          }
        })
        .catch(function (error) {
          console.log(error);
          self.centerDialogDni = false;
          self.dni = "";
          //reject(error);
        });
    },

    searchDistritoReverse(latitud, longitud) {
      axios
        .get(
          "https://api.geodir.co/geocoder/distritos/v1/findlatlon?geojson=" +
            encodeURIComponent(
              '{"type":"Point","coordinates":[' +
                longitud +
                "," +
                latitud +
                "]}"
            )
        )
        .then((response) => {
          const data = response.data.length != 0 ? response.data[0] : [];

          let distrito = data.distrito;

          if (Object.keys(data).length == 0) {
            $("#here").hide();

            this.marker = this.$store.state.markerSearcherReverse;

            if (this.marker) {
              this.map.removeLayer(this.marker);
            }
          } else {
            this.searchCodigoPostalReverse(latitud, longitud, distrito);
          }
        });
    },
    searchCodigoPostalReverse(latitud, longitud, distrito) {
      axios
        .get(
          "https://api.geodir.co/geocoder/codigo-postal/v1/findlatlon?geojson=" +
            encodeURIComponent(
              '{"type":"Point","coordinates":[' +
                longitud +
                "," +
                latitud +
                "]}"
            )
        )
        .then((response) => {
          const data = response.data.length != 0 ? response.data[0] : [];

          let codigo_postal = data.codigo_postal;

          $("#here-content").html(
            "<b>" +
              distrito +
              "</b><br>" +
              codigo_postal +
              "<br>" +
              latitud +
              ", " +
              longitud
          );
          $("#here").show();

          this.marker = this.$store.state.markerSearcherReverse;

          if (this.marker) {
            this.map.removeLayer(this.marker);
          }

          var customIcon = new L.Icon({
            iconUrl: require("../../assets/images/icon_marker_2.png"),
            //iconSize: [25, 35],
            iconAnchor: [12, 18],
            //popupAnchor: [0, -38]
          });

          this.marker = L.marker([latitud, longitud], {
            icon: customIcon,
          }).addTo(this.map);
          this.$store.commit("setMarkerSearcherReverse", this.marker);
        });
    },
    cancelHere() {
      $("#here").hide();
      this.marker = this.$store.state.markerSearcherReverse;
      if (this.marker) {
        this.map.removeLayer(this.marker);
      }
    },
  },
};
</script>

<style >
.app-center-widget-holder {
  position: absolute;
  left: 50%;
  bottom: 0;
  transition: bottom 0.1s linear, margin-bottom 0.1s linear;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  z-index: 999;
  width: 300px;
  max-width: 100%;
  margin-bottom: 20px;
}

/*#here .card-header {
		padding: 12px;
		border-bottom:0px !important;
		background-color: #fff !important;
		border-radius: 2px;
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
	}*/

#here .card-header {
  padding: 12px;
  border-bottom: 0px !important;
  background: #2f2f2f !important;
  color: white !important;
  border-radius: 2px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
}

.div-here {
  width: 240px;
  float: left;
  font-size: 13px;
  text-align: left;
}

.cardHere .close {
  margin: -5px -8px 0px 0px;
  width: 30px;
  height: 30px;
  float: right;
  color: white;
}

#here-content .coordinates {
  color: #8d8d8d;
}
.iconReverse {
  color: #8d8d8d;
}

.select-css {
  display: block;
  font-size: 16px;
  font-family: sans-serif;
  font-weight: 700;
  color: #444;
  line-height: 1.3;
  padding: 0.6em 1.4em 0.5em 0.8em;
  width: 100%;
  max-width: 100%; /* useful when width is set to anything other than 100% */
  box-sizing: border-box;
  margin: 0;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 0.5em;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  /* note: bg image below uses 2 urls. The first is an svg data uri for the arrow icon, and the second is the gradient. 
    for the icon, if you want to change the color, be sure to use `%23` instead of `#`, since it's a url. You can also swap in a different svg icon or an external image reference
    
  */
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E"),
    linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);
  background-repeat: no-repeat, repeat;
  /* arrow icon position (1em from the right, 50% vertical) , then gradient position*/
  background-position: right 0.7em top 50%, 0 0;
  /* icon size, then gradient */
  background-size: 0.65em auto, 100%;
}
/* Hide arrow icon in IE browsers */
.select-css::-ms-expand {
  display: none;
}
/* Hover style */
.select-css:hover {
  border-color: #888;
}
/* Focus style */
.select-css:focus {
  border-color: #aaa;
  /* It'd be nice to use -webkit-focus-ring-color here but it doesn't work on box-shadow */
  box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);
  box-shadow: 0 0 0 3px -moz-mac-focusring;
  color: #222;
  outline: none;
}

/* Set options to normal weight */
.select-css option {
  font-weight: normal;
}

/* Support for rtl text, explicit support for Arabic and Hebrew */
*[dir="rtl"] .select-css,
:root:lang(ar) .select-css,
:root:lang(iw) .select-css {
  background-position: left 0.7em top 50%, 0 0;
  padding: 0.6em 0.8em 0.5em 1.4em;
}

/* Disabled styles */
.select-css:disabled,
.select-css[aria-disabled="true"] {
  color: graytext;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22graytext%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E"),
    linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);
}

.select-css:disabled:hover,
.select-css[aria-disabled="true"] {
  border-color: #aaa;
}
</style>
